var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders"},_vm._l((_vm.finishedOrders),function(order){return _c('order',{key:order.id,attrs:{"order":order,"history":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }